import React from 'react'
import { ConfigProvider, List, StatusTip } from 'tea-component'
import { getLocale } from 'umi'

const SelectPanel = (props) => {
  const {
    loading,
    options = [],
    onSelectChange,
    value
  } = props

  return (
    <List
      type="option"
      className='dtb-db-tracking-day__list'
      boxClassName='dtb-db-tracking-day__list-box'
    >
      <ConfigProvider locale={getLocale() === 'zh-CN' ? 'zh' : "en"}>
        {
          loading ? (<List.StatusTip>
            <StatusTip status="loading" />
          </List.StatusTip>) :
            options?.map(item => (
              <List.Item
                key={item?.value}
                current={item?.value === value}
                onClick={() => onSelectChange(item)}
              >
                {item.text}
              </List.Item>
            ))
        }
      </ConfigProvider>
    </List>
  )
}

export default SelectPanel
